export default {"src":"/_next/static/media/GrassBrown.847eebdb.svg","height":72,"width":356,"blurWidth":0,"blurHeight":0};